module.exports = __webpack_public_path__ + "img/kipli-logo.a18bf82f.png";